import { Component, Input, ViewChild } from '@angular/core';

import { MediaPlayerComponent } from '@app/components/media-player/media-player.component';
import { Logger, NetworkService, AlertService } from '@app/services';
import { MediaPlayerService } from '@app/services/media-player/media-player.service';
import { BoardingVideo } from '@app/shared/models/multimedia/video.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-boarding-video',
  templateUrl: './boarding-video.component.html',
  styleUrls: ['./boarding-video.component.scss']
})
export class BoardingVideoComponent {
  @Input() video!: BoardingVideo;

  @ViewChild('player') player!: MediaPlayerComponent;

  invalidFormatMsg!: string;
  errorToastTitle!: string;
  invalidContentUrlMsg!: string;

  private logger = new Logger('BoardingVideoComponent');

  constructor(
    private network: NetworkService,
    private alertService: AlertService,
    private translate: TranslateService,
    public playerService: MediaPlayerService
  ) {
    this.getTranslations();
  }

  onPlay() {
    this.network.redirectIfOffline();
  }

  onEnterFullscreen() {
    this.playerService.enterFullscreenDevice(this.player);
  }

  onExitFullscreen() {
    this.playerService.exitFullscreenDevice(this.player);
  }

  onPlayerReady() {
    this.logger.debug(`Player is ready at ${new Date().toLocaleTimeString('es')}`);
  }

  onLoadstart() {
    this.logger.debug(`Video load has been started at ${new Date().toLocaleTimeString('es')}`);
  }

  onLoadedData() {
    this.logger.debug(`Video data has been loaded at ${new Date().toLocaleTimeString('es')}`);
  }

  onLoadedMetadata() {
    this.logger.debug(`Video metadata has been loaded at ${new Date().toLocaleTimeString('es')}`);
  }

  onCanplay() {
    this.logger.debug(`Video can be played at ${new Date().toLocaleTimeString('es')}`);
  }

  onStalled() {
    this.logger.debug(`Video stalled at ${new Date().toLocaleTimeString('es')}`);
    this.network.redirectIfOffline();
  }

  onMultimediaError(event) {
    const error = event.detail.plyr.media.error ? event.detail.plyr.media.error : {};
    this.logger.debug('Media player has errors: ', error);

    if (error.code === MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED) {
      let msg = this.invalidFormatMsg;

      if (!this.video.url) {
        msg = this.invalidContentUrlMsg;
      }

      this.alertService.showError(this.errorToastTitle, msg);
    }
  }

  private getTranslations() {
    this.translate.get('ERRORS_TOASTS.ERROR_TITLE').subscribe((msg) => {
      this.errorToastTitle = msg;
    });

    this.translate.get('ERRORS_TOASTS.INVALID_CONTENT_URL').subscribe((msg) => {
      this.invalidContentUrlMsg = msg;
    });

    this.translate.get('ERRORS_TOASTS.INVALID_FORMAT').subscribe((msg) => {
      this.invalidFormatMsg = msg;
    });
  }
}
